import React from 'react'
import { Box } from '@mui/material'
import { ShoesState } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { PriceDisplay } from 'src/Components/Domain/PriceDisplay'
import { calculatorOfShoesBaseCost, calculatorOfShoesEmbroideryCost, calculatorOfShoesOptionCost } from 'src/logic/calculateCost/shoes'
import { getPriceUnit } from 'src/util'

type Props = {
  state: ShoesState
}
export const ShoesPriceArea: React.FC<Props> = ({ state }) => {
  const { t, locale } = useLocale()
  const unit = getPriceUnit(locale)

  const basePrice = calculatorOfShoesBaseCost(state)
  const optionPrice = calculatorOfShoesOptionCost(state)
  const embroideryPrice = calculatorOfShoesEmbroideryCost(state)
  const postagePrice = 1100 // 税込
  const totalPrice = basePrice + embroideryPrice + optionPrice + postagePrice

  return (
    <Box border={'solid 1px #eee'} p={1} my={1}>
      <PriceDisplay priceLabel={`基本金額(アッパー素材)：`} priceValue={basePrice} unit={unit} />
      <PriceDisplay priceLabel={t.OPTION_PRICE} priceValue={optionPrice} unit={unit} />
      <PriceDisplay priceLabel={t.EMBROIDERY_PRICE} priceValue={embroideryPrice} unit={unit} />
      <PriceDisplay priceLabel={t.SHIPPING_PRICE} priceValue={postagePrice} unit={unit} />
      <PriceDisplay priceLabel={t.TOTAL_PRICE} priceValue={totalPrice} unit={unit} />
    </Box>
  )
}
